export default "__VITE_ASSET__BRcysE9z__"